import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { styled } from "@compiled/react";
import * as Sentry from "@sentry/react";
import { useConfig } from "../../hooks";
import { isUnpublishedEntry, isUnpublishedAsset } from "./view-model-error.types";
export const ViewModelError = ({ model }) => {
    if (isUnpublishedEntry(model) || isUnpublishedAsset(model)) {
        Sentry.captureException(new Error("View Model Error"), {
            tags: {
                team: "bxpt",
                modelType: model.sys.linkType,
                contentId: model.sys.id
            }
        });
    }
    const { environment } = useConfig();
    if (environment === "production") {
        return null;
    }
    const goToUrl = `https://app.contentful.com/spaces/rz1oowkt5gyp/environments/${environment}`;
    return (_jsxs(WarningBlock, { children: [isUnpublishedEntry(model) && (_jsxs(_Fragment, { children: [_jsxs(WarningText, { children: ["There is an unpublished ", _jsx("b", { children: "entry" }), " here."] }), _jsxs(WarningLink, { href: `${goToUrl}/entries/${model.sys.id}`, children: ["Go to entry ID: ", model.sys.id] })] })), isUnpublishedAsset(model) && (_jsxs(_Fragment, { children: [_jsxs(WarningText, { children: ["There is an unpublished ", _jsx("b", { children: "asset" }), " here."] }), _jsxs(WarningLink, { href: `${goToUrl}/assets/${model.sys.id}`, children: ["Go to asset ID: ", model.sys.id] })] }))] }));
};
const WarningBlock = styled.div `
    background-color: transparent;
    color: inherit;
    border-radius: 0.75rem;
    padding: 0.75rem 1.5rem;
    margin-bottom: 1rem !important;
    /* eslint-disable-next-line local/ensure-wac-token-usage -- Error component, hard-coded color acceptable */
    border: 2px dashed #de350b;
`;
const WarningText = styled.div({
    fontSize: "1.25rem"
});
const WarningLink = styled.a({
    fontSize: "1rem",
    textUnderlineOffset: "0.25rem"
});
//# sourceMappingURL=ViewModelError.js.map